import { createRoute } from '@tanstack/react-router';
import { appRoute } from './parent-routes';

const userManagementRoute = createRoute({
  getParentRoute: () => appRoute,
  path: 'user-management',
  component: () => null,
  staticData: {
    handle: { title: 'User Management' },
  },
});

export default userManagementRoute;
